import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GirisService } from '../services/giris.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private girisService: GirisService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    if (token) {
      request = request.clone({
        setHeaders: { 'Authorization': 'Bearer ' + JSON.parse(token).token }
      });
    }
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.error.Message == 'TOKEN EXPIRED') {
          const tokenStorage = localStorage.getItem('token');
          if (tokenStorage) {
            const userUid = JSON.parse(tokenStorage).userUid;
            this.girisService.refreshToken(userUid).subscribe(res => {
              localStorage.setItem('token', JSON.stringify(res.data));
            });
          }
        }
        return next.handle(request);
      })
    );
  }
}
